    
import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import { 
	Field,
	reduxForm,
	propTypes,
	formValueSelector,
	getFormSyncErrors,
	change,
} from 'redux-form'
import {
	bindActionCreators,
} from 'redux'
import { connect, } from 'react-redux'
import { PropTypes } from 'prop-types'
import { saveSeasonParticipant, savingSeasonParticipant, resetParticipantSettings } from "../../../redux/actions/seasonActions"
import { style, blue } from '../../../utils/constants'
import { onlypositivenumbers } from '../../../utils/functions/onlypositivenumbers'
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const formName       = 'seasonparticipants'
const participantTab = 6

class Participant extends Component {
	static propTypes = {
		...propTypes
	}
	constructor(props,context) {
		super(props,context)
		this.handleSaveParticipant = this.handleSaveParticipant.bind(this) 
		this.handleValueChange  = this.handleValueChange.bind(this)
	}
	componentDidUpdate() {
		const { initialize,datasaved,settingsSaved,resetform,resetParticipantSettings,resetDone,participantreset,dispatch } = this.props
		if (datasaved) {
			initialize({}, true)
			settingsSaved(true,participantTab)
		}
		if(resetform == true){
			resetParticipantSettings()
		}
		if(participantreset == true){
			dispatch(change(formName,'participantreset',false))
			resetDone()
		}
	}
	handleSaveParticipant() {
		const { saveSeasonParticipant, participants, settingsseason, dispatch } = this.props
		const season = participants[settingsseason]
		const seasonparticipant = {
			leagueMinAthleteMembershipPct:season.leagueMinAthleteMembershipPct,
			tournamentMinNumberAthletes:season.tournamentMinNumberAthletes,
			minAdvancerRatio:season.minAdvancerRatio,
			maxAdvancerRatio:season.maxAdvancerRatio,
			seasonId:settingsseason
		}
		dispatch(savingSeasonParticipant());
		saveSeasonParticipant(settingsseason,seasonparticipant);
	}
	handleValueChange() {
			const { dispatch, settingsSaved } = this.props
			dispatch(change(formName,'datasaved',false))
			settingsSaved(false,participantTab)
	}
	render() {
		const { participants, settingsseason, savingparticipant,datasaved,seasonyears, syncErrors } = this.props
		const season    = `participants[${settingsseason}]`   
		const errors    =  Object.values(syncErrors)
		const moveLeft  = {
			marginLeft: '-40px' 
		}
		let isSeasonSet = true
		if(participants) {
			isSeasonSet = participants[settingsseason].isSeasonSet
		}
		
		return (
			<Row className="center-block center-text">
				<form className="form-horizontal" sm={12}  style={{ padding:'0',margin:'0' }} >
					<Col sm={10}>
						<FormGroup>
							<SeasonHeader seasonyears={seasonyears} />   
						</FormGroup>
						{ (errors.length > 0) && <ErrorList errors={errors}/> }
						<FormGroup style={moveLeft}>
							<label className={style.lblattrs7}>League - Min # athletes with JG Membership &nbsp;%</label>
							<Field
								type='number'
								name={`${season}.leagueMinAthleteMembershipPct`}
								component='input'
								className="form-control no-spinners"
								style={{ maxWidth: '70px' }}
								onKeyDown={onlypositivenumbers}
								onChange={this.handleValueChange}                                        
							/>
						</FormGroup>
						<FormGroup  style={moveLeft}>
							<label className={style.lblattrs7}>Tournament - Minimum # athletes</label>
							<Field
								type='number'
								name={`${season}.tournamentMinNumberAthletes`}
								component='input'
								className="form-control no-spinners"
								style={{ maxWidth: '70px' }}
								onKeyDown={onlypositivenumbers}
								onChange={this.handleValueChange}                                       
							/>
						</FormGroup>
						<FormGroup  style={moveLeft}>
							<label className={style.lblattrs7}>Mininum Advancer Ratio &nbsp;1:</label>
							<Field
								type='number'
								name={`${season}.minAdvancerRatio`}
								component='input'
								className="form-control no-spinners"
								style={{ maxWidth: '50px' }}
								onKeyDown={onlypositivenumbers}  
								onChange={this.handleValueChange}                                      
							/>
						</FormGroup>
						<FormGroup  style={moveLeft}>
							<label className={style.lblattrs7}>Maximum Advancer Ratio &nbsp;1:</label>
							<Field
								type='number'
								name={`${season}.maxAdvancerRatio`}
								component='input'
								className="form-control no-spinners"
								style={{ maxWidth: '50px' }}
								onKeyDown={onlypositivenumbers}
								onChange={this.handleValueChange}                                      
							/>
						</FormGroup>														
						<FormGroup>
							<Col lgOffset={ 1 } lg={ 10 }>
								<button type="button"   className="btn btn-default"  style={{ marginLeft:'20px', color: blue, fontWeight: 800 }} onClick={this.handleSaveParticipant} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
									<i className={savingparticipant === true ? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
								</button>
								{
									datasaved && (<InfoSaved section='Season participants' />)
								}
							</Col>
						</FormGroup>
					</Col>
				</form>
			</Row>
		)
	}
}
function validate(values) {
	const { settingsseason, participants } = values
	const errors = {}
	if (participants && settingsseason) {
		const season = participants[settingsseason]
		const { leagueMinAthleteMembershipPct, tournamentMinNumberAthletes, minAdvancerRatio, maxAdvancerRatio } = season 
		let errorCounter = 0
		
		if(season.isSeasonSet)   {
			// check all values are provided
			if (!leagueMinAthleteMembershipPct) {
				errors[errorCounter++] = "Minimum # athletes with Junior Gold Membership is required"
			}
			if (!tournamentMinNumberAthletes) {
				errors[errorCounter++] = "Minimum # athletes is required"
			}
			if (!minAdvancerRatio) {
				errors[errorCounter++] = "Mininum Advancer Ratio"
			}
			if (!maxAdvancerRatio) {
				errors[errorCounter++] = "Maximun Advancer Ratio"
			}
		}
		else {
			errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab"            
		}  
	}
	return errors
} 
Participant.propTypes = {
	dispatch:PropTypes.func,
	initialize:PropTypes.func,
	syncErrors:PropTypes.object,
	settingsseason:PropTypes.number,
	savingparticipant:PropTypes.bool,
	datasaved:PropTypes.bool,
	seasonyears:PropTypes.string,
	participants:PropTypes.object,
	saveSeasonParticipant: PropTypes.func,
	savingSeasonParticipant: PropTypes.func,
	settingsSaved: PropTypes.func,
	resetParticipantSettings: PropTypes.func,
	resetDone:PropTypes.func,
	resetform:PropTypes.bool,
	participantreset:PropTypes.bool
 }
function mapStateToProps(state,ownProps){
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const settingsseason     = selector(state,'settingsseason')
	const participants       = selector(state,'participants')
	const savingparticipant         = selector(state,'savingparticipant')
	const datasaved          = selector(state,'datasaved')
	const participantreset   = selector(state,'participantreset')
	const syncErrors = getFormSyncErrors(formName)(state)
	return {     
		settingsseason,
		participants,
		savingparticipant,
		datasaved,
		participantreset,
		syncErrors  
	}
}
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		saveSeasonParticipant,
		savingSeasonParticipant,
		resetParticipantSettings
	},dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Participant))




// WEBPACK FOOTER //
// ./src/containers/season/components/Participant.js